import React from 'react';
import {Box} from '@mui/material';
import ArrBanner from '../../../components/common/arr-banner/ArrBanner';
import {Link} from 'react-router-dom';
import {ReactComponent as SuccessIcon} from '../../../../src/assets/images/success-icon.svg';
import {ReactComponent as InfoIcon} from '../../../../src/assets/images/info-icon.svg';
import {ReactComponent as AlertIcon} from '../../../../src/assets/images/alert-icon.svg';
import {ReactComponent as ErrorIcon} from '../../../../src/assets/images/error-icon.svg';
import {ReactComponent as LeftChevron} from '../../../../src/assets/images/left-chevron.svg';
import {ReactComponent as CloseIcon} from '../../../../src/assets/images/close-icon.svg';

const Demo: React.FC = () => {
  return (
    <Box className="demo-page banner-demo">
      <h1>ARR Banner</h1>
      <div>
        <Link to="/demo" className="link">
          {' '}
          Return back to demo
        </Link>
        <h1>Persistent</h1>
        <ArrBanner
          type="persistent"
          variant="success"
          bannerContent="Lorem ipsum"
          startIcon={<SuccessIcon />}
          dataTestId="demo-success-banner"
        />
        <br />
        <ArrBanner
          type="persistent"
          variant="info"
          bannerContent="Lorem ipsum"
          startIcon={<InfoIcon />}
          dataTestId="demo-info-banner"
        />

        <br />
        <ArrBanner
          type="persistent"
          variant="warning"
          bannerContent="Lorem ipsum"
          startIcon={<AlertIcon />}
          dataTestId="demo-warning-banner"
        />

        <br />
        <ArrBanner
          type="persistent"
          variant="error"
          bannerContent="Lorem ipsum"
          startIcon={<ErrorIcon />}
          dataTestId="demo-error-banner"
        />

        <br />

        <div>
          <h1>Contextual</h1>
          <ArrBanner
            type="contextual"
            variant="success"
            bannerContent="Lorem ipsum"
            startIcon={<SuccessIcon />}
            dataTestId="demo-success-icon-banner"
          />

          <br />
          <ArrBanner
            type="contextual"
            variant="warning"
            bannerContent="Lorem ipsum"
            startIcon={<AlertIcon />}
            dataTestId="demo-warning-icon-banner"
          />

          <br />
          <ArrBanner
            type="contextual"
            variant="error"
            bannerContent="Lorem ipsum"
            startIcon={<ErrorIcon />}
            dataTestId="demo-error-icon-banner"
          />
          <br />
          <ArrBanner
            type="contextual"
            variant="info"
            bannerContent="Lorem ipsum"
            startIcon={<InfoIcon />}
            dataTestId="demo-info-icon-banner"
          />
        </div>
        <div>
          <h1>Style Variations</h1>
          <ArrBanner
            type="persistent"
            variant="warning"
            startIcon={<AlertIcon />}
            bannerContent="Your search is taking longer than expected. Would you like to continue waiting or move it to the background and keep working?"
            actions={[
              {
                label: 'Continue Waiting',
                startIcon: <LeftChevron />,
                onClick: () => console.log('Retry'),
              },
              {
                label: 'Run in Background',
                startIcon: <LeftChevron />,
                onClick: () => console.log('Retry'),
              },
            ]}
            dataTestId="demo-warning-search-banner"
          />
          <br />
          <ArrBanner
            type="persistent"
            variant="info"
            bannerContent="Your search is taking longer than expected. Would you like to continue waiting or move it to the background and keep working?"
            startIcon={<InfoIcon />}
            actions={[
              {
                label: 'Dismiss',
                startIcon: <CloseIcon />,
                onClick: () => console.log('Retry'),
              },
            ]}
            dataTestId="demo-info-search-banner"
          />
        </div>
      </div>
    </Box>
  );
};

export default Demo;
